/**
 * AttractionMedia — brand text-card fallback used wherever we would otherwise
 * show a photo of a specific external subject (lake, trail, town, park, museum,
 * festival) that we don't have a verified photo of.
 *
 * Rule from ownership: attraction images may ONLY appear if the photo actually
 * depicts that place. Never a hotel photo, never a repeated generic scene.
 * When no verified photo exists → this styled brand card.
 */
export default function AttractionMedia({
  name,
  category,
  variant = "card",
  className = "",
}) {
  const aspect = variant === "hero" ? "aspect-[16/9] md:aspect-[21/9]" : "aspect-[4/3]";
  return (
    <div
      role="img"
      aria-label={`${name}${category ? ` — ${category}` : ""}`}
      className={`relative overflow-hidden bg-[#1A1A1A] ${aspect} ${className}`}
      data-testid={`attraction-media-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    >
      {/* Warm brand wash */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#B94A15] via-[#1A1A1A] to-[#1A1A1A]" />
      {/* Soft off-center glow */}
      <div
        className="absolute inset-0 opacity-40"
        style={{
          backgroundImage:
            "radial-gradient(60% 55% at 22% 30%, rgba(232,93,38,0.55) 0%, rgba(232,93,38,0) 60%), radial-gradient(50% 45% at 82% 78%, rgba(245,185,141,0.35) 0%, rgba(245,185,141,0) 60%)",
        }}
      />
      {/* Fine grid pattern */}
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #FDFBF7 1px, transparent 1px), linear-gradient(to bottom, #FDFBF7 1px, transparent 1px)",
          backgroundSize: "36px 36px",
        }}
      />
      <div className="relative h-full flex flex-col justify-end p-6 md:p-8">
        {category && (
          <div
            className="text-[10px] md:text-xs font-black uppercase tracking-[0.22em] text-[#FF9666]"
            style={{ fontFamily: "'Nunito', sans-serif" }}
          >
            {category}
          </div>
        )}
        <div
          className={`mt-2 font-black text-white leading-tight ${
            variant === "hero"
              ? "text-3xl sm:text-4xl md:text-5xl"
              : "text-2xl md:text-3xl"
          }`}
          style={{ fontFamily: "'Nunito', sans-serif" }}
        >
          {name}
        </div>
        <div className="mt-4 h-[3px] w-14 bg-[#E85D26]" aria-hidden="true" />
      </div>
    </div>
  );
}
